import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: 'end',
    display: 'flex',
    width: '100%',
    background: theme.palette.grey[800],
    padding: theme.spacing(1.3, 0.5, 1.3, 1.5),
    lineHeight: 0.8,
    minHeight: '-webkit-fit-content'
  },
  actions: {
    marginLeft: 'auto'
  },
  primaryActionButton: {
    color: theme.palette.common.white,
    padding: theme.spacing(1.25, 2, 0.5, 1),
    margin: theme.spacing(-0.5, -1)
  },
  secondaryActionsButton: {
    color: theme.palette.common.white,
    padding: theme.spacing(0.5, 1.5, 0.5, 2),
    margin: theme.spacing(0, 0, 0, 'auto')
  },
  actionsPlaceholder: {
    width: 0
  },
  totalHours: {
    display: 'flex',
    flexDirection: 'column'
  },
  totalCost: {
    display: 'flex',
    paddingLeft: theme.spacing(3),
    flexDirection: 'column'
  },
  totalLabel: {
    color: theme.palette.grey[400],
    fontSize: theme.typography.caption.fontSize,
    justifyContent: 'flex-start'
  },
  totalValue: {
    color: theme.palette.common.white,
    fontSize: theme.typography.body1.fontSize,
    justifyContent: 'flex-start',
    paddingTop: theme.spacing(0.25)
  },
  formattedHoursAndCost: {
    fontSize: theme.typography.body1.fontSize,
    padding: 0,
    color: theme.palette.common.white,
    textAlign: 'left'
  }
}));

export const formattedHoursAndCostStyles = makeStyles(theme => ({
  root: {
    fontSize: theme.typography.body1.fontSize,
    padding: 0,
    color: theme.palette.common.white,
    textAlign: 'left'
  }
}));

export const bulkActionStyles = makeStyles(theme => ({
  primaryActionButton: {
    color: theme.palette.common.white,
    padding: theme.spacing(1.25, 2, 0.5, 1),
    margin: theme.spacing(-0.5, -1)
  },
  secondaryActionsButton: {
    color: theme.palette.common.white,
    padding: theme.spacing(0.5, 1.5, 0.5, 2),
    margin: theme.spacing(0, 0, 0, 'auto')
  },
  actionsPlaceholder: {
    width: 0
  }
}));

export default useStyles;
